const config = {
  apiUrl: "http://api",
  apiUrlPci: null,
  features: {

  },
};

export default config;
// locally when you take the img to kub



// WEBPACK FOOTER //
// ./src/config/local.js